type DateColumnProps = {
  date: string | Date | null;
};

export default function DateColumn({ date }: DateColumnProps) {
  if (!date) return null;
  return new Date(date).toLocaleDateString();
}
